import { render, staticRenderFns } from "./ChineseMedicalMatter.vue?vue&type=template&id=70d8cb66&scoped=true&"
import script from "./ChineseMedicalMatter.vue?vue&type=script&lang=js&"
export * from "./ChineseMedicalMatter.vue?vue&type=script&lang=js&"
import style0 from "./ChineseMedicalMatter.vue?vue&type=style&index=0&id=70d8cb66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8cb66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSpacer})
